<template>
  <div class="advertise-opr">
    <up-preview
      class="advertise-opr__preview"
      width="90%"
      v-model="preview.visible"
      :initial-index="preview.activeIndex"
      :active-index="preview.activeIndex"
      :data="preview.data"
    >
      <template slot-scope="{ item }">
        <img v-if="isPicture" class="advertise-opr__preview-image" :src="item.path" />
        <video v-if="isVideo" class="advertise-opr__preview-image" :src="item.path" controls />
      </template>
    </up-preview>
    <div class="panel-header">
      <h3 class="panel-header__title">广告管理</h3>
      <span class="panel-header__subtitle">AD MANAGEMENT</span>
    </div>
    <div class="panel-content">
      <h3 class="panel-content__title">
        <span class="is-active" @click="$router.push({ name: 'advertiseList' })">广告管理</span>
        <span class="is-separator">&gt;</span>
        <span>{{type === 'edit' ? '编辑' : (type === 'view' ? '查看': '新增')}}广告</span>
      </h3>
      <up-form
        class="panel-content__form"
        :model="form"
        :rules="rules"
        ref="form"
        label-width="150px"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <up-form-item-select
          prop="aduser_id"
          label="广告主名称"
          filterable
          v-model="form.aduser_id"
          :data="data.adUsers"
          placeholder="请选择所属广告主"
          :disabled="disabledField"
          @up:select:change="getPlansByAdUserId"
        ></up-form-item-select>
        <up-form-item-select
          prop="order_id"
          label="计划名称"
          filterable
          v-model="form.order_id"
          :key-value="['order_name', 'id']"
          :data="data.plans"
          placeholder="请选择所属广告主"
          :disabled="disabledField"
          @up:select:change="handleAdPlanChange"
        ></up-form-item-select>
        <div v-show="form.order_id">
          <up-form-item label="媒体选择">{{currentPlan.media_name}}</up-form-item>
          <up-form-item label="广告位选择">{{currentPlan.place_name}}</up-form-item>
          <up-form-item-radio
            prop="create_type"
            label="素材类型"
            v-model="form.create_type"
            :data="data.createTypes"
            placeholder="请选择所属广告主"
          ></up-form-item-radio>
        </div>
        <up-form-item-input
          prop="ad_name"
          class="w364"
          label="广告名称"
          v-model="form.ad_name"
          placeholder="请输入广告名称"
        ></up-form-item-input>
        <!-- 素材管理 start -->
        <up-form-item-radio
          prop="jump_type"
          label="跳转行为"
          v-model="form.jump_type"
          :data="jumpTypes"
          :disabled="disabledField"
          @change="handleChangeJumpType"
        ></up-form-item-radio>
        <up-form-item-input
          v-if="form.jump_type === '2' && isAndroid"
          prop="apk_name"
          class="w364"
          label="包名"
          v-model="form.apk_name"
          placeholder="请输入包名"
        >
        <template slot="label">
            包名
            <up-tooltip effect="light" placement="right">
              <div slot="content">
                请联系客户侧技术人员获取
                <br />同一App在不同的应用商店可能使用的不同包名
              </div>
              <i class="icon iconfont icon-iconfontquestion"></i>
            </up-tooltip>
          </template>
        </up-form-item-input>
        <up-form-item-input
          v-if="form.jump_type === '2' && isIos"
          prop="apk_name"
          class="w364"
          label="AppID"
          v-model="form.apk_name"
          placeholder="请输入AppID"
          :rules="rules.app_id"
        >
        <template slot="label">
            AppID
            <up-tooltip effect="light" placement="right">
              <div slot="content">
                由于无需访问落地页，若客户有监测需求请用异步监测
                <br /> - 如何获取App ID：
                <p>
                  方法1：通过七麦（
                  <el-link href="https://www.qimai.cn/" type="primary" :underline="false" target="_blank">https://www.qimai.cn/</el-link>
                  ）搜索应用查看应用信息中的App ID
                </p>
                <p>
                  方法2：在AppStore（
                  <el-link href="https://www.apple.com.cn/ios/app-store/" type="primary" :underline="false" target="_blank">https://www.apple.com.cn/ios/app-store/</el-link>
                  ）搜索应用打开后通过URL尾部中的纯数字查看
                </p>
              </div>
              <i class="icon iconfont icon-iconfontquestion"></i>
            </up-tooltip>
          </template>
        </up-form-item-input>
       <up-form-item-radio
          label="优先从应用商店下载"
          :data="data.firstAppStore"
          v-if="form.jump_type === '2' && currentPlan.port_type === '2'"
          v-model="form.first_app_store"
          prop="first_app_store"
        ></up-form-item-radio>
        <!-- 落地页转化检测移除 -->
        <!-- <up-form-item-radio
          prop="conversion_monitor_type"
          v-if="form.jump_type !== '2'"
          label="落地页转化监测"
          v-model="form.conversion_monitor_type"
          :data="data.conversionMonitorTypes"
        ></up-form-item-radio> -->
        <!-- ios下载隐藏 -->
        <up-form-item v-if="!(isIos && form.jump_type === '2') " class="w364" prop="ad_url" label="落地页URL：">
          <up-input v-model="form.ad_url" placeholder="请输入落地页URL" @change="handleAdUrlChange"></up-input>
          <up-tooltip effect="light" placement="right">
            <div slot="content">系统会在链接地址后添加安全无害的效果统计参数，请点击验证添加后的地址有效。</div>
            <up-button class="ml5 mr10" type="primary" @click="openAdUrl">预览</up-button>
          </up-tooltip>
          <template>
            <span
              v-if="adUrl.text && !adUrl.checking"
              class="advertise-opr__landpage-message"
              :class="`${adUrl.valid ?'is-correct' : 'is-wrong' }`"
            >{{ `${adUrl.valid ? '√' : '×'} ${adUrl.text}` }}</span>
            <i v-if="adUrl.checking" class="el-icon el-icon-loading"></i>
          </template>
        </up-form-item>
        <up-form-item-input
          prop="deeplink"
          class="w364"
          label="deeplink"
          v-model="form.deeplink"
          placeholder="请输入deeplink"
          v-if="isApp"
        >
          <template slot="label">
            deeplink
            <up-tooltip effect="light" placement="right">
              <div slot="content">
                若用户已安装目标APP，用户点击广告后将直接打
                <br />开APP或跳转到APP指定页面，若您的广告不需此
                <br />功能请不要填写此项，以免造成跳转异常
              </div>
              <i class="icon iconfont icon-iconfontquestion"></i>
            </up-tooltip>
          </template>
        </up-form-item-input>
        <up-form-item prop="landing_page_pic">
          <div class="advertise-opr__landpage">
            <up-upload
              class="advertise-opr__landpage-upload"
              action="whatever"
              ref="upload"
              :file-list="fileList"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="handleOnChangeAdUrl"
              :disabled="disabledAdUrl"
            >
              <up-button
                size="small"
                type="primary"
                :style="{ 'cursor': disabledAdUrl ? 'not-allowed' : 'pointer' }"
                :disabled="disabledAdUrl"
              >
                {{ form.landing_page_pic ? '重新上传落地页长截图' : '上传落地页长截图' }}
                <i
                  class="el-icon-upload el-icon--right"
                ></i>
              </up-button>
            </up-upload>
            <div class="advertise-opr__landpage-tip">
              <up-tooltip effect="light" placement="right">
                <div slot="content">如链接为直接下载类链接，需上传应用内截图；如果是H5页面，需要提供落地页长截图。</div>
                <i class="icon iconfont icon-iconfontquestion"></i>
              </up-tooltip>
              <span class="item">格式：PNG或JPG，大小：小于150KB</span>
            </div>
            <div class="advertise-opr__landpage-pic" v-show="form.landing_page_pic">
              <img :src="form.landing_page_pic" />
            </div>
          </div>
        </up-form-item>
        <!-- supportedInformations -->
        <up-form-item prop="information" label="信息流展示样式" v-if="isFlow">
          <up-radio-group
            v-model="form.information"
            :disabled="disabledField"
            @up:radio-group:change="handleInformationChange"
          >
            <up-radio
              v-for="item in data.informations"
              :key="item.value"
              :label="item.value"
              :disabled="!supportedInformations.includes(item.value)"
            >{{item.name}}</up-radio>
          </up-radio-group>
        </up-form-item>
        <up-form-item label="素材尺寸">
          <up-radio-group
            :disabled="true"
            v-model="form.material_size"
            :data="[{ name: '固定尺寸上传', value: '0' }, { name: '按比例上传', value: '1' }]"
          ></up-radio-group>
          <div>
            <ul
              class="advertise-opr__material-size clearfix"
              v-if="form.material_size === '0' && materialSize.sizes.length"
            >
              <li
                v-for="item in materialSize.sizes"
                :key="item.size_id"
                :class="{ 'is-active': materialSize.matchedSizes.indexOf(item.size) > -1 }"
              >{{ item.size }}</li>
            </ul>
          </div>
          <div
            class="advertise-opr__material-scale"
            v-if="form.material_size === '1' && materialSize.scaleData"
          >
            <span>宽高比：{{materialSize.scaleData.scale}}</span>
            <span>最低上传尺寸{{materialSize.scaleData.min_size}}</span>
          </div>
        </up-form-item>
        <div class="advertise-opr__group">
          <div class="advertise-opr__list" v-for="(material, index) in form.materials" :key="index">
            <div class="advertise-opr__item">
              <template v-if="isFlow">
                <up-form-item-input
                  class="w364"
                  :prop="`materials.${index}.title`"
                  :rules="[{ required: false, message: '请输入广告标题', trigger: 'blur' }, { min: 0, max: 50, message: '广告标题不能超过50个字符', trigger: 'blur' }]"
                  label="广告标题"
                  v-model="material.title"
                  placeholder="请输入广告标题"
                ></up-form-item-input>
                <up-form-item-input
                  class="w364"
                  :prop="`materials.${index}.spread_name`"
                  :rules="{ min: 0, max: 14, message: '推广名称不能超过14个字符', trigger: 'blur' }"
                  label="推广名称"
                  v-model="material.spread_name"
                  placeholder="请输入推广名称"
                ></up-form-item-input>
              </template>
              <up-form-item
                label="素材上传"
                :prop="`materials.${index}.files`"
                :rules="{ type: 'array', required: true, min: 1, message: '请上传素材', trigger: 'change' }"
              >
                <up-upload
                  multiple
                  action="whatever"
                  :file-list="material.fileList"
                  :auto-upload="false"
                  :show-file-list="false"
                  :on-change="(file, fileList) => handleOnChange(file, fileList, index)"
                >
                  <up-button size="large" type="primary">
                    批量上传{{ isVideo ? '视频' : '图片' }}
                    <i
                      class="el-icon-upload el-icon--right"
                    ></i>
                  </up-button>
                  <div slot="tip" class="advertise-opr__upload-tip">{{ uploadTipText }}</div>
                </up-upload>
                <up-table
                  class="advertise-opr__table"
                  border
                  align="center"
                  :page="material.page"
                  :width-columns="{ preview: '300px', size: '100px', code: '100px' }"
                  :slotContents="['preview', 'path', 'match']"
                  @cell-click="(row, column) => handleCellClick({ row, column }, index)"
                >
                  <template slot="preview:content" slot-scope="{ row }">
                    <img v-if="isPicture" class="is-preview" :src="row.preview" />
                    <video v-if="isVideo" class="is-preview" :src="row.preview"></video>
                  </template>
                  <template slot="path:content" slot-scope="{ row }">
                    <a class="is-path" :href="row.path" target="_blank">{{ row.path }}</a>
                  </template>
                  <template slot="match:content" slot-scope="{ row }">
                    <span
                      class="icon iconfont"
                      :class="`${row.match ? 'icon-right': 'icon-wrong'}`"
                    ></span>
                  </template>
                  <template slot="up:operate">
                    <up-table-column label="操作">
                      <template slot-scope="scope">
                        <up-upload
                          class="advertise-opr__replace"
                          action="whatever"
                          :auto-upload="false"
                          :show-file-list="false"
                          :on-change="(file, fileList) => handleOnChange(file, fileList, index, scope)"
                          :disabled="material.replacing[scope.$index]"
                        >
                          <up-button size="small" type="primary">
                            替换
                            <i
                              v-if="material.replacing[scope.$index]"
                              class="el-icon el-icon-loading"
                            ></i>
                          </up-button>
                        </up-upload>
                        <up-button
                          size="small"
                          class="is-remove ml5"
                          type="primary"
                          @click="handleRemoveMaterial(index, scope)"
                        >删除</up-button>
                        <!-- <up-popover
                          placement="top"
                          width="160"
                          v-model="material.visibles[scope.$index]"
                          hasFooter
                          @up:confirm="handleRemoveMaterial(index, scope)"
                        >
                          <p>确定要删除该素材吗？</p>
                          <up-button
                            slot="reference"
                            size="small"
                            class="is-remove ml5"
                            type="primary"
                          >
                            删除
                            <i
                              v-if="material.removing[scope.$index]"
                              class="el-icon el-icon-loading"
                            ></i>
                          </up-button>
                        </up-popover> -->
                      </template>
                    </up-table-column>
                  </template>
                </up-table>
              </up-form-item>
            </div>
            <div class="advertise-opr__btns">
              <!-- <up-popover
                v-if="form.materials.length > 1"
                placement="top"
                width="160"
                v-model="material.visible"
                hasFooter
                @up:confirm="handleRemoveMaterial(index)"
              >
                <p>确定要删除该素材组吗？</p>
                <up-button slot="reference" class="is-remove ml5" type="primary">删除素材组</up-button>
              </up-popover> -->
              <up-button v-if="form.materials.length > 1" class="is-remove ml5" type="primary" @click="handleRemoveMaterial(index)">删除素材组</up-button>
              <up-button
                class="advertise-opr__btn"
                :disabled="type === 'view'"
                @click="handleAddMaterial(index)"
              >增加素材组</up-button>
            </div>
          </div>
        </div>
        <!-- 素材管理 end -->
        <!-- 开屏交互引导文案  -->
        <up-form-item-radio
          prop="interaction_mode"
          label="交互方式"
          v-model="form.interaction_mode"
          :data="interactionModeOptions"
          @change="handleChangeJumpType"
          v-if="isOpenScreen"
        >
        <template slot="label">
            交互方式
            <up-tooltip effect="light" placement="right">
              <div slot="content">
                滑动轨迹支持范围：NGA iOS App 版本>=7.3.2、NGA 安卓App版本
                <br /> >=9.3.4。(即需要内嵌iOS广告SDK>=6.11、安卓广告SDK>=6.9)
                <br />旧版本App上会处理兼容为点击类型
              </div>
              <i class="icon iconfont icon-iconfontquestion"></i>
            </up-tooltip>
          </template>
        </up-form-item-radio>
        <template v-if="isTrailShow">
          <el-form-item label="轨迹颜色" prop="trail_color">
            <el-color-picker v-model="form.trail_color" show-alpha :predefine="predefineColors"></el-color-picker>
          </el-form-item>
          <up-form-item-input label="轨迹粗细" type="number" prop="trail_weight"  placeholder="请输入正整数" v-model.number="form.trail_weight"></up-form-item-input>
          <up-form-item-radio
          prop="guide_mode"
          v-model="form.guide_mode"
          :data="guideModeOptions"
        >
        <template slot="label">
            引导提示
            <up-tooltip effect="light" placement="right">
              <div slot="content">
                【素材内绘制】客户需要自行在素材内画出引导线、引导文案。建议也画出手势提高互动率。
                <br />【系统默认样式】客户无需将引导画进素材。仅需填写引导文案，引导动画由系统在展示时绘制，
              </div>
              <i class="icon iconfont icon-iconfontquestion"></i>
            </up-tooltip>
          </template>
        </up-form-item-radio>
        </template>
        <up-form-item-input v-if="isOpenScreenText" label="开屏交互引导文案" class="w364" placeholder="请输入开屏引导文案, 不超过14字" prop="open_screen_guide_text" v-model="form.open_screen_guide_text"></up-form-item-input>
        <up-form-item-input v-if="isOpenScreenTextWarning" label="警示语" class="w364" placeholder="请输入开屏警示语, 不超过14字" prop="warning_text" v-model="form.warning_text">
          <template slot="label">
            警示语
            <up-tooltip effect="light" placement="right">
              <div slot="content">
                旧版本App上，警示语字段会用作按钮引导文案
              </div>
              <i class="icon iconfont icon-iconfontquestion"></i>
            </up-tooltip>
          </template>
        </up-form-item-input>
        <!-- 投放规则 -->
        <up-form-item-radio
          prop="m_play"
          label="轮播规则"
          v-model="form.m_play"
          :data="data.mPlays"
          :disabled="disabledField"
        ></up-form-item-radio>
        <template v-if="isCPT">
          <up-form-item-radio
            v-if="!(isPreview || isInternal)"
            prop="carousel"
            label="轮播"
            v-model="form.carousel"
            :data="data.carousels"
            @up:radio:change="handleCarouselChange"
          ></up-form-item-radio>
          <up-form-item-input
            prop="pay_univalent"
            class="w364"
            label="结算单价"
            v-model="form.pay_univalent"
          >
            <template slot="up:input:append">元</template>
          </up-form-item-input>
          <up-form-item prop="provinces" label="投放地域">
            <ny-area
              style="margin-left: 16px;"
              :default-value="defaultProvinces"
              v-model="form.provinces"
              v-bind="data.provinces"
              :disabled="disabledField"
              @change="handleProvinceChange"
            ></ny-area>
          </up-form-item>
        </template>
        <up-form-item v-else prop="cities" label="投放地域">
          <ny-region-picker
            ref="regionPicker"
            :datasource="data.cities"
            v-model="form.cities"
            :formated-value.sync="defaultCities"
            @change="handleRegionPickerChange"
          ></ny-region-picker>
        </up-form-item>
        <up-form-item label="投放时间" :prop="putTimeType === 0 ? 'date' : 'is_long_time'">
          <up-radio-group
            component="el-radio-button"
            size="small"
            v-model="putTimeType"
            :data="putTimeTypeOptions"
            @up:radio-group:change="handlePutTimeType"
          ></up-radio-group>
          <dateRange2
            v-if="putTimeType === 0"
            class="advertise-opr__date-range ml16 mt20"
            ref="date"
            page-info="advertise"
            :type24="false"
            :disabledType="true"
            :default-date="defaultDate"
            :receive-data="receiveData"
            :receive-date-range="receiveDateRange"
            :disabledTime="disabledTime"
            @selectedCycle="handleDateSelect"
          ></dateRange2>
          <span
            v-if="putTimeType === 0"
            style="position: absolute; left: 280px; top: 0; margin-left: 6px;"
            :style="form.time.length > 60 ? 'color: #F56C6C' : 'color: #909399'"
          >选择排期总天数最多只支持60天</span>
        </up-form-item>
        <!-- <up-form-item-input prop="budget" class="w364" label="日预算" v-model="form.budget"></up-form-item-input> -->
        <up-form-item-radio
          v-if="!isCPT"
          prop="plan_hour_type"
          label="投放控制/时"
          v-model="form.plan_hour_type"
          :data="data.planHourTypes"
        ></up-form-item-radio>
        <template v-if="isApp">
          <up-form-item-radio
            prop="is_device_oriented"
            label="设备定向"
            v-model="form.is_device_oriented"
            :data="data.devices"
          ></up-form-item-radio>
          <up-form-item prop="media_ids" v-if="form.is_device_oriented === '1'">
            <up-transfer
              class="advertise-opr__device"
              v-model="form.media_ids"
              :titles="['选择设备', '已选设备']"
              :props="{ key: 'value', label: 'name' }"
              filterable
              :filter-method="filterMethod"
              filter-placeholder="请输入搜索内容"
              :data="isAndroid ? data.androidDevices : data.iOSDevices"
            ></up-transfer>
          </up-form-item>
          <up-form-item-radio
            v-if="isYNW"
            prop="is_oriented"
            label="人群定向"
            v-model="form.is_oriented"
            :data="data.crowds"
          ></up-form-item-radio>
          <div v-if="form.is_oriented === '1'">
            <div class="advertise-opr__crowd">
              <div class="advertise-opr__crowd-group">
                <h3>人口属性</h3>
                <div class="advertise-opr__crowd-list">
                  <div class="advertise-opr__crowd-item">
                    <span class="advertise-opr__crowd-type">年龄</span>
                    <up-form-item-checkbox prop="age" withAll v-model="form.age" :data="data.ages"></up-form-item-checkbox>
                  </div>
                  <div class="advertise-opr__crowd-item">
                    <span class="advertise-opr__crowd-type">性别</span>
                    <up-form-item-checkbox prop="sex" withAll v-model="form.sex" :data="data.sexes"></up-form-item-checkbox>
                  </div>
                  <!-- <div class="advertise-opr__crowd-item">
                    <span class="advertise-opr__crowd-type">关键人生阶段</span><up-form-item-checkbox withAll v-model="form.stages_life" :data="data.stagesLifes"></up-form-item-checkbox>
                  </div>
                  <div class="advertise-opr__crowd-item">
                    <span class="advertise-opr__crowd-type">学历信息</span><up-form-item-checkbox withAll v-model="form.education" :data="data.educations"></up-form-item-checkbox>
                  </div>
                  <div class="advertise-opr__crowd-item">
                    <span class="advertise-opr__crowd-type">职业信息</span><up-form-item-checkbox withAll v-model="form.career" :data="data.careers"></up-form-item-checkbox>
                  </div>-->
                </div>
              </div>
              <div class="advertise-opr__crowd-group">
                <h3>经济状况</h3>
                <div class="advertise-opr__crowd-list">
                  <div class="advertise-opr__crowd-item">
                    <span class="advertise-opr__crowd-type">收入信息</span>
                    <up-form-item-checkbox
                      prop="income"
                      withAll
                      v-model="form.income"
                      :data="data.incomes"
                    ></up-form-item-checkbox>
                  </div>
                  <!-- <div class="advertise-opr__crowd-item">
                    <span class="advertise-opr__crowd-type">是否有房</span><up-form-item-checkbox withAll v-model="form.house" :data="data.houses"></up-form-item-checkbox>
                  </div>
                  <div class="advertise-opr__crowd-item">
                    <span class="advertise-opr__crowd-type">是否有车</span><up-form-item-checkbox withAll v-model="form.car" :data="data.cars"></up-form-item-checkbox>
                  </div>-->
                </div>
              </div>
              <div class="advertise-opr__crowd-group">
                <h3>兴趣偏好</h3>
                <div class="advertise-opr__crowd-list">
                  <div class="advertise-opr__crowd-item">
                    <span class="advertise-opr__crowd-type">基础兴趣</span>
                    <up-form-item-checkbox
                      prop="hobby"
                      withAll
                      v-model="form.hobby"
                      :data="data.hobbies"
                    ></up-form-item-checkbox>
                  </div>
                  <div class="advertise-opr__crowd-item" v-if="isN">
                    <span class="advertise-opr__crowd-type">游戏分类</span>
                    <up-form-item-checkbox
                      prop="game_type"
                      withAll
                      v-model="form.game_type"
                      :data="data.gameTypes"
                    ></up-form-item-checkbox>
                  </div>
                </div>
              </div>
              <div class="ny-crowd__group" v-if="isAppInterest">
                <!-- 只在安卓展示 -->
                <h3>应用兴趣</h3>
                <up-form-item-checkbox
                  multiple
                  withAll
                  prop="app_interest"
                  v-model="form.app_interest"
                  :data="data.appInterests"
                ></up-form-item-checkbox>
              </div>
            </div>
          </div>
          <!-- <up-form-item-checkbox prop="network_way" label="运营商" withAll v-model="form.network_way" :data="data.networkWays"></up-form-item-checkbox>
          <up-form-item-checkbox prop="operator" label="联网方式" withAll v-model="form.operator" :data="data.operators"></up-form-item-checkbox>-->
          <!-- 广告监控 -->
        </template>
        <up-form-item-radio
          v-if="!isM"
          prop="is_black_white"
          label="黑白名单"
          v-model="form.is_black_white"
          :data="blackWhites"
        ></up-form-item-radio>
        <template v-if="form.is_black_white === '1' || form.is_black_white === '0'">
          <!-- <up-form-item-radio
            class="advertise-opr__bw-type"
            prop="black_white.key"
            v-model="form.black_white.key"
            :data="data.blackWhiteKeys"
            :rules="{ required: true, message: '请选择黑白名单类型', trigger: 'change' }"
          ></up-form-item-radio>-->
          <up-form-item
            prop="black_white.value"
            :rules="{ required: true, message: '请上传黑白名单', trigger: 'change' }"
          >
            <div class="advertise-opr__bw">
              <up-upload
                class="advertise-opr__bw-upload"
                action="whatever"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="handleBlackWhiteChange"
              >
                <up-button size="small" type="primary">
                  上传黑白名单
                  <i v-if="uploadingTpl" class="el-icon el-icon-loading"></i>
                </up-button>
              </up-upload>
              <a class="advertise-opr__bw-template" :href="templateUrl">下载模板</a>
              <span class="advertise-opr__bw-url">{{form.black_white.value}}</span>
            </div>
            <span
              class="advertise-opr__bw-tip"
            >上传的文件格式为txt文件，文件大小不得超过50M，每行只写一个任意类型的设备号或ip，系统自动判断类型。</span>
          </up-form-item>
        </template>
        <up-form-item-radio
          v-if="isShowNGAOrigen"
          label="NGA板块定向"
          required
          v-model="form.ngaOrient"
          :data="data.ngaOptions"
        >
        </up-form-item-radio>
        <up-form-item v-if="isShowNGAOrigen">
          <div class="advertise-opr__nga" v-if="form.ngaOrient">
            <tree-transfer
            :title="ngaTitle"
            :from_data="data.ngaOrients"
            :to_data="data.toData"
            node_key="id"
            modol="transfer"
            pid="pid"
            :rootPidValue="0"
            ref="ngaOrient"
            :filter="true"
            @add-btn="handleNgaAdd"
            @remove-btn ="handleNgaRemove"
            :defaultCheckedKeys="form.nga_section_ids"
            :defaultTransfer="true"
            ></tree-transfer>
          </div>
        </up-form-item>
        <up-form-item-radio
          prop="monitor_type"
          label="监控类型"
          v-model="form.monitor_type"
          :data="data.monitorTypes"
        ></up-form-item-radio>
        <template v-if="form.monitor_type !== '0'">
          <up-form-item label="第三方曝光监测(异步)" class="advertise-opr__monitor">
            <el-form-item
              v-for="(item, index) in form.monitor_pv_urls"
              :key="item.key + index"
              :prop="'monitor_pv_urls.'+index+'.value'"
              class="w364"
              :rules="[{ required: true, validator: validateUrls(true), trigger: 'blur' }]"
            >
              <el-input class="mr10" v-model="item.value"></el-input>
              <el-button  @click.prevent="handleAddMonitor('monitor_pv_urls')">添加</el-button>
              <el-button v-if="form.monitor_pv_urls.length > 1" @click="handleRemoveMonitor(item, 'monitor_pv_urls')">删除</el-button>
            </el-form-item>
          </up-form-item>
          <up-form-item label="第三方点击监测(异步)" class="advertise-opr__monitor">
            <el-form-item
              v-for="(item, index) in form.monitor_urls"
              :key="item.key  + index"
              :prop="'monitor_urls.'+index+'.value'"
              class="w364"
              :rules="[{ required: true, validator: validateUrls(false), trigger: 'blur' }]"
            >
              <el-input class="mr10" v-model="item.value"></el-input>
              <el-button  @click.prevent="handleAddMonitor('monitor_urls')">添加</el-button>
              <el-button v-if="form.monitor_urls.length > 1" @click="handleRemoveMonitor(item, 'monitor_urls')">删除</el-button>
            </el-form-item>
          </up-form-item>
          <!-- <up-form-item-input
            prop="monitor_pv_urls"
            class="w364"
            label="第三方曝光监测"
            v-model="form.monitor_pv_urls"
          ></up-form-item-input> -->
          <!-- <up-form-item-input
            prop="monitor_urls"
            class="w364"
            label="第三方点击监测"
            v-model="form.monitor_urls"
          ></up-form-item-input> -->
        </template>
        <div class="panel-content__btn-group">
          <div class="panel-content__btn" v-if="type !== 'view'">
            <up-button size="large" type="primary" @click="submitForm('form')">{{ btnText('提交') }}</up-button>
          </div>
          <div class="panel-content__btn">
            <up-button size="large" class="is-cancel" @click="$router.go(-1)">取消</up-button>
          </div>
        </div>
      </up-form>
    </div>
  </div>
</template>

<script>
import { NyArea, dateRange2, NyRegionPicker } from '@/global/components'
import { get, capturedGet, capturedPost, capturedPut } from '@/manager/http'
import treeTransfer from 'el-tree-transfer'
import { groupBy, availableDate } from '@/global/util/util'
import { getHexColor2, getRgba } from '@/global/util/rgbaHex'
import { BASE_URL } from '@/global/util/constants'
import bus from '@/global/util/bus'
import { mapActions } from 'vuex'
const h = bus.$createElement
const REGEXP_WEBSITE_URL = /^https?:\/\//

// create_type 1 图片 2 视频
// material_type 1 主素材 2 封面 3 icon

export default {
  name: 'advertise-opr',
  components: {
    NyArea,
    dateRange2,
    NyRegionPicker,
    treeTransfer
  },
  data() {
    const validateAdName = async (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入广告名称'))
      } else if (value.length > 50) {
        callback(new Error('广告名称不能超过50个字符'))
      } else {
        const [, res] = await capturedGet(`/${this.platform}/ads/is-repeated?ad_name=${value}`)
        if (
          res.data.status === 1 &&
          (
            ['add', 'copy'].includes(this.type) ||
            (this.type === 'edit' && this.originalAdName !== value)
          )
        ) {
          callback(new Error('广告名称已经存在'))
        } else {
          callback()
        }
      }
    }

    const validateAdUrlRelated = (message) => async (rule, value, callback) => {
      if (value === '') {
        callback(new Error(message))
      } else if (this.form.ad_url) { // 已经输入了落地页URL
        this.$refs.form.validateField('ad_url')
      } else {
        callback()
      }
    }
    const validateApkName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入包名'))
      } else if (value.length > 100) {
        callback(new Error('包名超过不能100个字符'))
      } else {
        const regx = /^([a-zA-Z_][a-zA-Z0-9_]*)+([.][a-zA-Z_][a-zA-Z0-9_]*)+$/
        if (!regx.test(value)) {
          callback(new Error('格式须符合 xx.xx.xx或 xx.xx.xx.xx。包名每段需由字母开头'))
        } else {
          callback()
        }
      }
    }
    const validateAppID = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入AppID'))
      } else if (!/^[0-9]*[1-9][0-9]*$/.test(value)) {
        callback(new Error('AppID需为数字'))
      } else {
        callback()
      }
    }
    const validateAdUrl = async (rule, value, callback) => {
      this.adUrl.valid = false
      this.adUrl.hasChecked = this.adUrl.last === value
      if (value === '') {
        callback(new Error('请输入落地页URL'))
      } else if (!REGEXP_WEBSITE_URL.test(value)) {
        callback(new Error('落地页URL必须输入以 http 或 https 开头'))
      } else {
        const field = ['order_id', 'jump_type', 'conversion_monitor_type'].find(v => !this.form[v])
        if (field) {
          this.$refs.form.validateField(field)
        } else {
          if (!this.adUrl.hasChecked) await this.checkAdUrl()
          else {
            this.adUrl.valid = true
          }
          callback()
          // const valid = await this.checkAdUrl()
          // if (!valid) {
          //   callback(new Error('落地页URL异常无法解析，请重新输入'))
          // } else {
          //   callback()
          // }
        }
      }
    }

    const validatePayUnivalent = (rule, value, callback) => {
      const reg = /^(\d|[1-9]\d+)(\.\d+)?$/
      if (value === '' || !reg.test(value)) {
        if (!/^[\\.\d]+$/.test(value)) this.form.pay_univalent = this.form.pay_univalent.replace(/[^\d\\.]/g, '')
        callback(new Error('请输入结算单价'))
      } else if (Number(value) < 0 || Number(value) > 9999999) {
        callback(new Error('结算单价必须在0~9999999之间'))
      } else {
        callback()
      }
    }

    // const validateBudget = (rule, value, callback) => {
    //   if (value || value === '0') {
    //     if (Number(value) < 100 || Number(value) > 9999999) {
    //       callback(new Error('日预算必须在100~9999999之间'))
    //     } else if (!/^[0-9]*[1-9][0-9]*$/.test(value)) {
    //       this.form.budget = this.form.budget.replace(/[^\d]/g, '')
    //       callback(new Error('日预算必须是正整数'))
    //     } else {
    //       callback()
    //     }
    //   } else {
    //     callback()
    //   }
    // }

    const validateUrls = this.validateUrls = (isPv) => (rule, value, callback) => {
      if (this.form.monitor_type === '0' || (value && REGEXP_WEBSITE_URL.test(value))) callback()
      const text = isPv ? '曝光' : '点击'
      const type = isPv ? 'monitor_urls' : 'monitor_pv_urls'
      if (value === '') {
        const isEmpty = this.form[type].some(item => item.value !== '')
        if (!isEmpty) {
          callback(new Error(`请输入第三方${text}监测`))
        } else {
          callback()
        }
      } else if (!REGEXP_WEBSITE_URL.test(value)) {
        callback(new Error(`第三方${text}必须以 http 或 https 开头`))
      }
    }

    return {
      isShowNGAOrigen: false, // 是否展示nga板块定向
      isEditFirst: true,
      predefineColors: [ // 预定颜色
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        'rgba(255, 69, 0, 0.68)',
        'rgb(255, 120, 0)',
        'hsv(51, 100, 98)',
        'hsva(120, 40, 94, 0.5)',
        'hsl(181, 100%, 37%)',
        'hsla(209, 100%, 56%, 0.73)',
        '#c7158577'
      ],
      platform: '',
      type: '',
      id: '',
      originalAdName: '',
      placeId: '',
      covers: [[]], // 信息流视频封面
      ngaTitle: ['选择定向', '已选定向'],
      putTimeType: 1,
      putTimeTypeOptions: [
        { name: '从今日起长期投放', value: 1 },
        { name: '指定日期时间范围', value: 0 }
      ],
      interactionModeOptions: [
        { name: '点击', value: '0' },
        { name: '滑动轨迹', value: '1' }
      ],
      guideModeOptions: [
        { name: '素材内绘制', value: '0' },
        { name: '系统默认样式', value: '1' }
      ],
      form: {
        aduser_id: '',
        order_id: '',
        create_type: '1',
        ad_name: '',
        ad_type: '0',
        jump_type: '', // 跳转行为
        deeplink: '',
        apk_name: '',
        fisrt_app_store: '',
        conversion_monitor_type: '',
        ad_url: '', // 落地页
        landing_page_pic: '',
        information: '',
        material_size: '0', // 单选：0（固定尺寸上传），复选及通投 1（按比例上传）
        filenames: [],
        open_screen_guide_text: '', // 根据跳转行为展示默认文字
        interaction_mode: '0', // 开屏交互方式
        trail_color: 'rgba(0, 0, 0, 1)', // 轨迹颜色
        trail_weight: 5, // 轨迹宽度
        guide_mode: '1', // 交互类型
        warning_text: '',
        materials: [{
          title: '',
          spread_name: '',
          fileList: [],
          replaceList: [],
          page: new this.$page({
            header: { preview: '素材', path: '素材名称', size: '素材尺寸', match: '是否匹配' }
          }),
          files: [],
          replacing: [],
          removing: [],
          visibles: [], // 删除素材组中的素材标识
          visible: false // 删除素材组标识
        }],
        m_play: '2', // 轮播规则 默认素材
        carousel: '4', // 默认独占
        // carouselClone: '', // 记录初始编辑的值
        pay_univalent: '', // 结算单价
        provinces: ['-1'], // cpt 投放地域
        cities: [], // cpc,cpm 投放地域
        date: [],
        time: [],
        // budget: '', // 日预算
        plan_hour_type: '', // 投放控制/时
        is_long_time: 1,
        is_device_oriented: '2', // 设备定向 默认否
        is_oriented: '2', // 人群定向 默认否
        age: [],
        sex: [],
        // stages_life: [],
        // education: [],
        // career: [],
        income: [],
        // house: [],
        // car: [],
        hobby: [],
        app_interest: [], // 应用兴趣
        game_type: [],
        media_ids: [], // 设备定向
        // network_way: [], // 联网方式
        // operator: [], // 运营商
        is_black_white: '2', // 黑白名单 默认无
        black_white: {
          key: '',
          value: ''
        },
        ngaOrient: 0, // 是否nga板块定向
        nga_section_ids: [], // nga板块定向id
        add_nga_section_ids: [],
        monitor_type: '0', // 监控类别 默认无
        monitor_pv_urls: [{
          key: Date.now(),
          value: ''
        }], // 曝光监测
        monitor_urls: [{
          key: Date.now(),
          value: ''
        }] // 点击监测
      },
      rules: {
        aduser_id: [{ required: true, message: '请选择所属广告主', trigger: 'change' }],
        order_id: [{ required: true, validator: validateAdUrlRelated('请选择所属计划'), trigger: 'change' }],
        ad_name: [{ required: true, validator: validateAdName, trigger: 'blur' }],
        jump_type: [{ required: true, validator: validateAdUrlRelated('请选择跳转行为'), trigger: 'change' }],
        apk_name: [
          { required: true, validator: validateApkName, trigger: 'blur' }
        ],
        app_id: [
          { required: true, validator: validateAppID, trigger: 'blur' }
        ],
        first_app_store: [{ required: true, message: '请选择是否优先从应用商店下载', trigger: 'change' }],
        conversion_monitor_type: [{ required: true, validator: validateAdUrlRelated('请选择落地页转化监测'), trigger: 'change' }],
        ad_url: [{ required: true, validator: validateAdUrl, trigger: 'blur' }],
        information: [{ required: true, message: '请选择信息流展示样式', trigger: 'change' }],
        m_play: [{ required: true, message: '请选择轮播规则', trigger: 'change' }],
        carousel: [{ required: true, message: '请选择轮播', trigger: 'change' }],
        pay_univalent: [{ type: 'number', required: true, validator: validatePayUnivalent, trigger: 'change' }],
        provinces: [{ type: 'array', required: true, message: '请选择投放地域', trigger: 'change' }],
        cities: [{ type: 'array', required: true, message: '请选择投放地域', trigger: 'change' }],
        date: [{ type: 'array', required: true, message: '请选择投放时间', trigger: 'change' }],
        is_long_time: [{ required: true, message: '请选择投放策略', trigger: 'change' }],
        // budget: [{ type: 'number', validator: validateBudget, trigger: 'change' }],
        plan_hour_type: [{ required: true, message: '请选择投放控制/时', trigger: 'change' }],
        is_device_oriented: [{ required: true, message: '请选择设备定向', trigger: 'change' }],
        is_oriented: [{ required: true, message: '请选择人群定向', trigger: 'change' }],
        age: [{ type: 'array', required: true, message: '请选择年龄', trigger: 'change' }],
        sex: [{ type: 'array', required: true, message: '请选择性别', trigger: 'change' }],
        income: [{ type: 'array', required: true, message: '请选择收入信息', trigger: 'change' }],
        hobby: [{ type: 'array', required: true, message: '请选择基础兴趣', trigger: 'change' }],
        app_interest: [{ type: 'array', required: true, message: '请选择应用兴趣', trigger: 'change' }],
        game_type: [{ type: 'array', required: true, message: '请选择游戏分类', trigger: 'change' }],
        media_ids: [{ type: 'array', required: true, message: '请选择设备', trigger: 'change' }],
        is_black_white: [{ required: true, message: '请选择黑白名单', trigger: 'change' }],
        // black_white: [{ required: true, type: 'object', fields: { key: { required: true, message: '请选择黑白名单类型', trigger: 'change' }, value: { required: true, message: '请上传黑白名单', trigger: 'change' } } }],
        monitor_type: [{ required: true, message: '请选择监控类型', trigger: 'change' }],
        monitor_pv_urls: [{ required: true, validator: validateUrls(true), trigger: 'blur' }],
        monitor_urls: [{ required: true, validator: validateUrls(false), trigger: 'blur' }],
        open_screen_guide_text: [
          { required: true, message: '请输入开屏交互引导文案', trigger: 'blur' },
          { max: 14, message: '引导文案不能超过14个字', trigger: 'blur' }
        ],
        interaction_mode: [{ required: true, message: '选择交互方式', trigger: 'change' }],
        trail_color: [{ required: true, message: '请选择轨迹颜色', trigger: 'blur' }],
        trail_weight: [
          { required: true, pattern: /^[1-9]\d*$/, message: '请输入正整数', trigger: 'blur' }
        ],
        guide_mode: [{ required: true, message: '请选择引导提示', trigger: 'change' }],
        warning_text: [
          { required: true, message: '请输入开屏交互警示语', trigger: 'blur' },
          { max: 14, message: '警示语不能超过14个字', trigger: 'blur' }
        ]
      },
      prority: '',
      currentPlan: {}, // 选中的计划
      jumpTypes: [], // 跳转行为
      supportedInformations: [], // 支持的信息流展示类型
      defaultProvinces: [], // 默认选中的省份
      defaultCities: {},
      checkedCities: {},
      defaultDate: [], // 日期 start
      receiveData: [],
      receiveDateRange: [],
      disabledTime: {}, // 日期 end
      templateUrl: `${BASE_URL}/admin/ads/ad/blackwhite`, // 模板地址
      uploadingTpl: false,
      data: {
        adUsers: [],
        plans: [],
        createTypes: [],
        jumpTypes: [],
        conversionMonitorTypes: [],
        informations: [],
        mPlays: [],
        carousels: [],
        firstAppStore: [], // 是否优先从应用商店下载
        provinces: {
          entire: [],
          provinces: []
        },
        ngaOptions: [
          { name: '是', value: 1 },
          { name: '否', value: 0 }
        ], // nga 板块定向
        ngaOrients: [], // nga板块定向内容
        toData: [], // 穿梭框右侧数据
        cities: [],
        planHourTypes: [],
        devices: [],
        androidDevices: [],
        iOSDevices: [],
        crowds: [],
        ages: [],
        sexes: [],
        // stagesLifes: [],
        // educations: [],
        // careers: [],
        incomes: [],
        // houses: [],
        // cars: [],
        hobbies: [],
        gameTypes: [],
        appInterests: [], // 应用兴趣
        // networkWays: [],
        // operators: [],
        blackWhites: [],
        blackWhiteKeys: [],
        monitorTypes: []
      },
      adUrl: {
        text: '', // 落地页检测结果
        checking: false,
        valid: false, // 落地页是否合法
        isPicExist: false, // 落地页图片是否存在
        hasChecked: false, // 是否已经验证过了
        last: '' // 上一个 url
      },
      materialSize: {
        sizes: [],
        matchedSizes: [],
        scaleData: {}
      },
      fileList: [],
      loading: false,
      isApp: true,
      isFlow: true,
      isMotivate: false, // 激励视频
      isCPT: true,
      isYNW: true, // 引力资讯，NGA，英威诺
      isM: false, // 小米
      isN: false, // NGA
      isZ: false, // 掌阅
      // onlyN: false, // 仅有NGA
      // notOnlyN: false, // 不只有 NGA
      // onlyM: false, // 小米
      // notOnlyM: false, // 不只有小米
      isAndroid: true,
      isIos: false, // 是否是ios
      isAppInterest: false, // 是否展示 应用兴趣
      submiting: false,
      submited: false,
      verifying: false,
      isOpenScreen: false, // 是否开屏广告
      preview: { // 预览
        visible: false,
        activeIndex: -1,
        data: []
      }
    }
  },
  computed: {
    disabledAdUrl() {
      return !this.adUrl.valid || this.adUrl.isPicExist
    },
    btnText() {
      return function (text) {
        return this.submiting ? `${text}中...` : this.submited ? `已${text}` : text
      }
    },
    isPicture() {
      return this.form.create_type === '1'
    },
    isVideo() {
      return this.form.create_type === '2' || this.form.create_type === '3'
    },
    isInternal() {
      return this.prority === '10'
    },
    isBidding() {
      return this.prority === '20'
    },
    isBrand() {
      return this.prority === '30'
    },
    isPreview() {
      return this.prority === '40'
    },
    blackWhites() {
      return this.data.blackWhites.map(v => ({ ...v, disabled: this.isPreview ? v.value === '2' : false }))
    },
    isTrailShow() { // 是否展示轨迹
      return this.form.interaction_mode === '1'
    },
    isOpenScreenText() {
      return this.isOpenScreen && (this.isOpenScreenTextWarning || this.form.interaction_mode === '0')
    },
    isOpenScreenTextWarning() {
      return this.isOpenScreen && this.form.guide_mode === '1' && this.form.interaction_mode === '1'
    },
    disabledField() {
      return ['edit', 'view'].includes(this.type)
    },
    uploadTipText() {
      let text
      if (this.isM) { // 小米
        text = '小米渠道仅允许上传jpg格式文件，小图、组图不超过100K，大图不超过500K'
      } else if (this.isZ) { // 掌阅
        text = '支持上传 jpg/jpeg/png/gif 格式文件，且不超过150KB'
      } else {
        text = '支持上传 jpg/jpeg/png 格式文件，不超过150K；gif 格式文件，不超过2M'
      }
      return this.isPicture ? text : `只支持上传 mp4 格式文件，且不超过${(this.isFlow || this.isMotivate) ? '50' : '3'}M`
    }
  },
  watch: {
    'form.create_type' (newVal, oldVal) {
      if (newVal && oldVal) {
        this.handleCreateTypeChange()
      }
    }
  },
  methods: {
    ...mapActions('advertise/', ['getNgaOrient', 'getFirstAppStoreOptions']),
    async getAdUsers() {
      const [err, res] = await capturedGet(`/${this.platform}/advertiser/adminselect`)
      if (err || res.code !== 1) this.$message.error((err || res).msg || '获取广告主列表失败！')
      else {
        this.data.adUsers = res.code === 1 ? res.data : []
      }
    },
    async getPlansByAdUserId(value) {
      if (!['edit', 'view', 'copy'].includes(this.type)) {
        this.$refs.form.resetFields()
        this.currentPlan = {}
        this.form.aduser_id = value
      }

      const [err, res] = await capturedGet(`/${this.platform}/order/get-orders-for-ad/${value}`)
      if (err || res.code !== 1) this.$message.error((err || res).msg || '获取计划列表失败！')
      else {
        this.data.plans = res.code === 1 ? res.data : []
      }
    },
    async getCreateTypes(placeId) {
      const [err, res] = await capturedGet('/interface/place/attribute/create_type', { place: placeId })
      if (err || res.code !== 1) this.$message.error((err || res).msg || '获取素材类型失败！')
      else {
        this.data.createTypes = res.code === 1 ? res.data : []
      }
    },
    async getJumpTypes(placeId) {
      const [err, res] = await capturedGet('/interface/place/attribute/jump_type', { place: placeId })
      if (err || res.code !== 1) this.$message.error((err || res).msg || '获取跳转行为失败！')
      else {
        this.data.jumpTypes = res.code === 1 ? res.data : []
        this.jumpTypes = this.data.jumpTypes
        if (this.form.jump_type !== '3') {
          this.jumpTypes = this.jumpTypes.filter(item => item.value !== '3')
        }
      }
    },
    async getSupportedInformations(placeId) {
      const [err, res] = await capturedGet(`/interface/place/information?place_id=${placeId}`)
      if (err || res.code !== 1) this.$message.error((err || res).msg || '获取支持的信息流展示样式失败！')
      else {
        this.supportedInformations = res.code === 1 ? res.data.map(String) : []
      }
    },
    async getPlaceMaterials(id, information = '0') {
      const [err, res] = await capturedGet(`/${this.platform}/ads/ad/getplacematerials`, {
        id, information, material_type: '0'
      })
      if (err || res.code !== 1) this.$message.error((err || res).msg || '获取素材尺寸失败！')
      else {
        this.materialSize.sizes = res.code === 1 ? res.data.map(v => ({
          ...v,
          size: `${v.width}*${v.height}`
        })) : []

        // 重置上传的素材匹配状态
        this.updateMaterialsStatus()
        this.updateMaterialSizeStatus()
      }
    },
    // 更新跳转行为
    handleChangeJumpType() {
      if (!this.isEditFirst || ['add'].includes(this.type)) {
        const openScreenMsg = {
          '1-0': '跳转详情页或第三方应用',
          '2-0': '下载或跳转第三方应用',
          '3-0': '跳转详情页或第三方应用',
          '1-1': '向上滑动',
          '2-1': '向上滑动',
          '3-1': '向上滑动'
        }
        const openWarningMsg = {
          '1-0': '跳转详情页或第三方应用',
          '2-0': '下载或跳转第三方应用',
          '3-0': '跳转详情页或第三方应用',
          '1-1': '跳转详情页或第三方应用',
          '2-1': '下载或跳转第三方应用',
          '3-1': '跳转详情页或第三方应用'
        }
        this.form.open_screen_guide_text = openScreenMsg[`${this.form.jump_type}-${this.form.interaction_mode}`]
        this.form.warning_text = openWarningMsg[`${this.form.jump_type}-${this.form.interaction_mode}`]
      }
    },
    // 更新素材尺寸匹配状态
    updateMaterialSizeStatus() {
      this.materialSize.matchedSizes = this.form.materials.reduce((prev, cur) => {
        for (let item of cur.page.data) {
          if (!prev.includes(item.size) && this.isMatch(item.size)[0]) {
            prev.push(item.size)
          }
        }
        return prev
      }, [])
    },
    // 更新所有素材匹配状态
    updateMaterialsStatus() {
      this.form.materials = this.form.materials.map((material, index) => {
        material.files.splice(0)
        material.page.data = material.page.data.map(item => {
          const [matched, matchedSize] = this.isMatch(item.size)
          item.match = matched
          if (matched) {
            const file = {
              path: item.path,
              id: item.id,
              size: item.size,
              size_id: matchedSize.size_id,
              code: '1'
            }
            if (this.isVideo) {
              file.file_size = item.file_size
              file.seconds = item.seconds
            }
            material.files.push(file)
          }
          return item
        })
        this.$refs.form.validateField(`materials.${index}.files`)
        return material
      })
    },
    async handleAdPlanChange(value) {
      // 优先级
      const currentPlan = this.data.plans.find(plan => plan.id === value)
      if (currentPlan) {
        this.prority = currentPlan.prority
      }
      const [err, res] = await capturedGet(`${this.platform}/order/get-order-info/${value}`)
      if (err || res.code !== 1) this.$message.error((err || res).msg || '获取计划失败！')
      else {
        this.currentPlan = res.code === 1 ? res.data : {}
        const { id, payment, port_type: portType, place_attribute: placeAttribute, place_id: placeId, media } = this.currentPlan
        this.isApp = ['1', '2'].includes(portType)
        this.isFlow = placeAttribute === '2'
        this.isMotivate = placeAttribute === '11'
        this.isOpenScreen = placeAttribute === '1'
        this.isCPT = payment === 'cpt'
        this.isAndroid = portType === '2'
        this.isIos = portType === '1'
        this.isAppInterest = portType === '2'
        this.isYNW = ['1', '2', '11'].includes(media) // 引力资讯、NGA、英威诺
        this.isM = media === '94' // 小米
        this.isN = media === '2' // NGA
        this.isZ = media === '106' // 掌阅
        this.placeId = placeId
        this.defaultProvinces = ['-1']
        // 获取素材类型
        this.getCreateTypes(placeId)
        this.getJumpTypes(placeId)

        // 处理跳转行为，android 平台下没有“直接下载”选项
        // if (this.isAndroid) this.jumpTypes = this.data.jumpTypes.filter(v => v.value !== '2')
        // else this.jumpTypes = this.data.jumpTypes

        this.materialSize.sizes.splice(0)
        if (!['edit', 'view', 'copy'].includes(this.type)) {
          this.form.information = ''
          this.$nextTick(_ => {
            this.$refs.form.clearValidate('information')
          })
        }
        if (this.isFlow) {
          // 获取广告位支持的信息流展示样式
          await this.getSupportedInformations(placeId)
        }

        // 素材尺寸
        if (!this.isFlow || this.supportedInformations.length === 0) {
          this.getPlaceMaterials(id, '0')
        }

        // 重置时间
        if (this.form.material_size === '0') { // 固定尺寸上传
          this.resetDate({ type: this.type === 'edit' ? 'now' : 'add' })
        }
        // 获取nga板块定向
        this._getNgaOrient(placeId)
      }
    },
    // NGA板块定向 start
    async _getNgaOrient(placeId) {
      // eslint-disable-next-line no-unused-vars
      const result = await this.getNgaOrient({ data: { place_ids: placeId } })
      this.data.ngaOrients = result.data
      this.isShowNGAOrigen = result.data.length > 0
      this.data.toData = []
    },
    // 获取是否应用商店下载
    async _getFirstAppStoreOptions() {
      const result = await this.getFirstAppStoreOptions()
      this.data.firstAppStore = result.data
      if (!this.form.first_app_store) {
        this.form.first_app_store = result.data[0].value
      }
    },
    handleNgaAdd(fromData, toData, obj) {
      this.form.add_nga_section_ids = this.getNgaOrientId(toData)
    },
    handleNgaRemove(fromData, toData, obj) {
      this.form.add_nga_section_ids = this.getNgaOrientId(toData)
    },
    getNgaOrientId(toData) {
      return toData.reduce((prev, cur) => {
        if (cur.children && cur.children.length < 1) {
          prev.push({
            id: cur.id,
            children: []
          })
        } else {
          prev.push({
            id: cur.id,
            children: [...this.getNgaOrientId(cur.children)]
          })
        }
        return prev
      }, [])
    },

    // NGA板块定向end
    filterMethod(query, item) {
      return item.name.indexOf(query) > -1
    },
    async checkAdUrl() {
      const { conversion_monitor_type: type, ad_url: url, jump_type: jumpType } = this.form
      this.adUrl.text = ''
      this.adUrl.checking = true
      const [err, res] = await capturedGet(`/${this.platform}/ads/ad/handle_url`, { order_id: this.currentPlan.id, conversion_monitor_type: type, url, jump_type: jumpType })
      this.adUrl.text = res.msg
      this.adUrl.checking = false
      if (err || res.code !== 1) { // 验证失败
        this.adUrl.valid = false
      } else { // 成功
        this.adUrl.valid = true
        this.adUrl.isPicExist = res.data && res.data.status === 1
      }
      this.adUrl.last = url // 上一个 url
      return this.adUrl.valid
    },
    handleCreateTypeChange() { // 素材类型改变，清除素材
      this.form.materials.splice(0, this.form.materials.length, {
        title: '',
        spread_name: '',
        fileList: [],
        replaceList: [],
        page: new this.$page({
          header: { preview: '素材', path: '素材名称', size: '素材尺寸', match: '是否匹配' }
        }),
        files: [],
        replacing: [],
        removing: [],
        visibles: [], // 删除素材组中的素材标识
        visible: false // 删除素材组标识
      })

      this.updateMaterialsStatus()
      this.updateMaterialSizeStatus()
    },
    handleAdUrlChange() {
      this.form.ad_url = this.form.ad_url.replace(/\s+/g, '') // 移除空格
    },
    openAdUrl() {
      window.open(this.form.ad_url, '_tab')
    },
    async uploadPicture(file) {
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('information', this.form.information || '0')
      return await capturedPost(`/${this.platform}/ads/ad/upload`, formData, { 'Content-Type': 'multipart/form-data' })
    },
    async uploadVideo(file) {
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('place', this.placeId)
      formData.append('information', this.form.information || '0')

      if (this.isFlow || this.isMotivate) { // 信息流视频，会返回封面
        formData.append('is_cover', 1)
      }

      // formData.append('information', this.form.information || '0')
      return await capturedPost(`/${this.platform}/ads/ad/upload-video`, formData, { 'Content-Type': 'multipart/form-data' })
    },
    beforeUploadAdUrl(file) {
      const isSupport = ['image/jpeg', 'image/png', 'image/jpg'].includes(file.raw.type);
      const isLt150KB = file.raw.size / 1024 < 150;

      if (!isSupport) {
        this.$message.error('落地页长截图只能是 png, jpg, jpeg 格式！');
      }
      if (!isLt150KB) {
        this.$message.error('落地页长截图大小不能超过 150KB！');
      }
      return isSupport && isLt150KB
    },
    async handleOnChangeAdUrl(file, fileList) {
      if (!this.beforeUploadAdUrl(file)) return

      const [err, res] = await this.uploadPicture(file)
      if (err || res.code !== 1) this.$message.error((err || res).msg || '上传落地页长截图失败！')
      else {
        this.fileList.splice(0, this.fileList.length, file)
        const { path } = res.data
        this.form.landing_page_pic = path
      }
    },
    // 信息流展示样式变化了
    handleInformationChange(value) {
      this.getPlaceMaterials(this.currentPlan.id, value)
    },
    handleCellClick({ row, column }, index) {
      if (column.property === 'preview') {
        const data = this.form.materials[index].page.data
        this.preview.visible = true
        this.preview.activeIndex = data.indexOf(row)
        this.preview.data = data
      }
    },
    beforeUploadPictureMaterial(file) {
      const { type, size } = file.raw
      const isSupport = ['image/jpeg', 'image/png', 'image/gif', 'image/jpg'].includes(type)
      const isGIF = type === 'image/gif'
      const isJPG = ['image/jpeg', 'image/jpg'].includes(type)
      const isLt100KB = size / 1024 < 100; // 小米 jpg
      const isLt500KB = size / 1024 < 500; // 小米 jpg
      const isLt150KB = size / 1024 < 150; // 掌阅 gif
      const isLt2M = size / 1024 / 1024 < 2;
      const isLarge = this.form.information === '3' // 大图

      // if (this.isM) { // 小米
      //   text = '小米渠道仅允许上传jpg格式文件，小图、组图不超过100K，大图不超过500K'
      // } else if (this.isZ) { // 掌阅
      //   text = '支持上传 jpg/jpeg/png/gif 格式文件，且不超过150KB'
      // } else {
      //   text = '支持上传 jpg/jpeg/png 格式文件，不超过150K；gif 格式文件，不超过2M'
      // }

      if (this.isM) { // 小米
        if (!isJPG) {
          this.$message.error('小米渠道图片素材只能是 jpg 格式！')
        } else {
          if (isLarge && !isLt500KB) {
            this.$message.error('小米渠道大图图片素材大小不能超过 500k！')
          } else if (!isLarge && !isLt100KB) {
            this.$message.error('小米渠道小图、组图图片素材大小不能超过 100k！')
          }
        }
      } else {
        if (!isSupport) {
          this.$message.error('图片素材只能是 png, jpg, jpeg, gif 格式！');
        }
        if (!isLt150KB && (this.isZ || !isGIF)) {
          this.$message.error('图片素材大小不能超过 150KB！');
        }
        if (!this.isZ && isGIF && !isLt2M) {
          this.$message.error('图片素材大小不能超过 2M！');
        }
      }

      return this.isM ? isJPG && ((isLarge && isLt500KB) || (!isLarge && isLt100KB))
        : isSupport && (((this.isZ || !isGIF) && isLt150KB) || (!this.isZ && isGIF && isLt2M))
    },
    beforeUploadVideoMaterail(file) {
      const isSupport = ['video/mp4'].includes(file.raw.type);
      const isLt3M = file.raw.size / 1024 / 1024 <= 3;
      const isLt50M = file.raw.size / 1024 / 1024 <= 50;

      if (!isSupport) {
        this.$message.error('视频素材只能是 mp4 格式！');
      }

      if (!this.isFlow && !this.isMotivate && !isLt3M) {
        this.$message.error('视频素材大小不能超过 3MB！');
      } else if (this.isFlow && !isLt50M) {
        this.$message.error('信息流视频素材大小不能超过 50MB！');
      } else if (this.isMotivate && !isLt50M) {
        this.$message.error('激励视频素材大小不能超过 50MB！');
      }

      return isSupport && ((!this.isFlow && !this.isMotivate && isLt3M) || (this.isFlow && isLt50M) || (this.isMotivate && isLt50M));
    },
    isMatch(size) {
      size = this.materialSize.sizes.find(v => v.size === size)
      return [!!size, size]
    },
    validateUploadMaterial(data, size) {
      const groupedData = groupBy(data.filter(v => v.match), 'size') // 分组后匹配的素材
      const groupedSizes = Object.keys(groupedData)
      const information = this.form.information
      if (groupedSizes.length === 0) return true

      if (this.isFlow && groupedSizes.length === 1) { // 信息流
        if (information !== '2') {
          this.$message.error(`${information === '1' ? '小图' : '大图'}只能上传一张图片素材！`)
          return false
        }

        if (!groupedSizes.includes(size)) { // 已经上传 1 种尺寸
          this.$message.error('组图只能上传一种尺寸！')
          return false
        } else if (groupedData[size].length === 3) { // 已经上传 3 张
          this.$message.error('组图只能上传三张图片素材！')
          return false
        }
      } else if (groupedSizes.includes(size) && groupedData[size].length === 1) {
        this.$message.error('每个尺寸只能上传一张图片素材！')
        return false
      }

      return true
    },
    validateUploadVideo(data, size) {
      const groupedData = groupBy(data.filter(v => v.match), 'size') // 分组后匹配的素材
      const groupedSizes = Object.keys(groupedData)
      const information = this.form.information
      if (groupedSizes.length === 0) return true

      if (this.isFlow && groupedSizes.length === 1) { // 信息流视频
        if (information !== '2') { // 非组图
          this.$message.error(`${information === '1' ? '小图' : '大图'}只能上传一个视频素材！`)
          return false
        }

        if (!groupedSizes.includes(size)) { // 已经上传 1 种尺寸
          this.$message.error('组图只能上传一种尺寸！')
          return false
        } else if (groupedData[size].length === 3) { // 已经上传 3 张
          this.$message.error('组图只能上传三个视频素材！')
          return false
        }
      } else if (groupedSizes.includes(size) && groupedData[size].length === 1) {
        this.$message.error('每个尺寸只能上传一个视频素材！')
        return false
      } else if (groupedSizes.includes(size) && groupedData[size].length === 1) {
        this.$message.error('每个尺寸只能上传一个视频素材！')
        return false
      }

      return true
    },
    // 上传素材
    async handleOnChange(file, fileList, index, scope) {
      if (!this.form.order_id) {
        this.$message.error('请先选择计划！')
        return this.$refs.form.validateField('order_id')
      }

      if (this.isFlow && !this.form.information) {
        this.$message.error('请先选择信息流展示样式！')
        return this.$refs.form.validateField('information')
      }

      if (scope) {
        if (this.form.materials[index].replacing[scope.$index]) return
        this.form.materials[index].replacing.splice(scope.$index, 1, true)
      }

      if (this.isPicture && !this.beforeUploadPictureMaterial(file)) return
      if (this.isVideo && !this.beforeUploadVideoMaterail(file)) return

      let material
      let [matched, matchedSize] = []
      let { path, size, seconds, fileSize, coverPath } = {}

      if (this.isPicture) {
        const [err, res] = await this.uploadPicture(file)
        if (scope) this.form.materials[index].replacing.splice(scope.$index, 1, false)
        if (err || res.code !== 1) this.$message.error((err || res).msg || '上传图片素材失败！')
        else {
          ({ path, size } = res.data)
          ;[matched, matchedSize] = this.isMatch(size)
          if (matched && (!scope || !scope.row.match) && !this.validateUploadMaterial(this.form.materials[index].page.data, size)) return

          material = { preview: path, path, size, match: matched }
        }
      } else if (this.isVideo) {
        const [err, res] = await this.uploadVideo(file)
        if (scope) this.form.materials[index].replacing.splice(scope.$index, 1, false)
        if (err || res.code !== 1) this.$message.error((err || res).msg || '上传视频素材失败！')
        else {
          ({ path, size, seconds, file_size: fileSize, cover_path: coverPath } = res.data)
          ;[matched, matchedSize] = this.isMatch(size)
          if (!this.isFlow && !this.isMotivate && seconds > 5) {
            return this.$message.error('视频素材时长不能超过5秒') // 信息流视频不限制时长
          }
          if (matched && (!scope || !scope.row.match) && !this.validateUploadVideo(this.form.materials[index].page.data, size)) return

          material = { preview: path, path, size, match: matched, seconds, file_size: fileSize, coverPath }
        }
      }

      if (!scope) { // 上传
        this.form.materials[index].visibles.push(false)
        this.form.materials[index].replacing.push(false)
        this.form.materials[index].removing.push(false)
        this.form.materials[index].page.data.push(material)
      } else { // 替换
        material.id = scope.row.id
        this.form.materials[index].page.data.splice(scope.$index, 1, material)
        if (scope.row.match) {
          this.form.materials[index].files = this.form.materials[index].files.filter(v => v.path !== scope.row.path)

          if ((this.isFlow || this.isMotivate) && this.isVideo) { // 信息流视频 或者 激励视频
            this.covers.splice(index, 1, this.covers[index].filter(v => v.path !== scope.row.coverPath))
          }
        }
      }

      if (this.isPicture) {
        !scope ? this.$message.success('上传图片素材成功！') : this.$message.success('替换图片素材成功！')
      } else if (this.isVideo) {
        !scope ? this.$message.success('上传视频素材成功！') : this.$message.success('替换视频素材成功！')
      }

      if (matched) {
        const item = {
          path,
          id: material.id,
          size,
          size_id: matchedSize.size_id,
          code: '1'
        }

        const cover = JSON.parse(JSON.stringify(item))

        if (this.isVideo) {
          item.seconds = seconds
          item.file_size = fileSize

          if (this.isFlow || this.isMotivate) { // 信息流视频
            item.material_type = 1
            item.create_type = 2
          }
        }

        this.form.materials[index].files.push(item)
        this.covers[index].push({ ...cover, path: coverPath, material_type: 2, create_type: 1 })
      }
      this.$refs.form.validateField(`materials.${index}.files`)

      // 更新素材尺寸状态
      this.updateMaterialSizeStatus()
    },
    // 删除素材
    async handleRemoveMaterial(index, scope) {
      if (this.type === 'view') return
      // if (scope && this.form.materials[index].removing[scope.$index]) return

      // let ids = []
      // if (scope && scope.row.id) {
      //   if (this.form.materials[index].page.data.length > 1) {
      //     ids.push(scope.row.id)
      //   }
      // } else {
      //   ids = this.form.materials[index].page.data.reduce((prev, cur) => {
      //     if (cur.id) {
      //       prev.push(cur.id)
      //     }
      //     return prev
      //   }, [])
      // }

      // if (ids.length > 0) {
      //   if (scope) this.form.materials[index].removing.splice(scope.$index, 1, true)
      //   const [err, res] = await capturedGet(`/${this.platform}/ads/ad/delplacematerials`, { ids: ids.join(',') })
      //   if (scope) this.form.materials[index].removing.splice(scope.$index, 1, false)
      //   if (err || res.code !== 1) return this.$message.error((err || res).msg || '删除素材失败！')
      // }

      if (scope) {
        this.form.materials[index].visibles.splice(scope.$index, 1)
        this.form.materials[index].replacing.splice(scope.$index, 1)
        this.form.materials[index].removing.splice(scope.$index, 1)
        this.form.materials[index].page.data.splice(scope.$index, 1)

        if (scope.row.match) { // 过滤 files
          this.form.materials[index].files = this.form.materials[index].files.filter(v => v.path !== scope.row.path)

          if ((this.isFlow || this.isMotivate) && this.isVideo) {
            this.covers.splice(index, 1, this.covers[index].filter(v => v.path !== scope.row.coverPath))
          }
        }
      } else {
        this.form.materials.splice(index, 1)
        this.covers.splice(index, 1) // 移除信息流视频封面
      }
      // this.$message.success('删除素材成功！')
      // 更新素材尺寸选中状态
      this.updateMaterialSizeStatus()
    },
    // 添加素材
    handleAddMaterial(index) {
      const { title, spread_name: spreadName, files } = this.form.materials[index]
      if (this.isFlow) {
        if (title.length > 50) {
          this.$refs.form.validateField(`materials.${index}.title`)
          return this.$message.error('广告标题不能超过50个字符！')
        }

        if (spreadName.length > 14) {
          this.$refs.form.validateField(`materials.${index}.spread_name`)
          return this.$message.error('推广名称不能超过14个字符！')
        }
      }

      if (!files.length) {
        this.$refs.form.validateField(`materials.${index}.files`)
        return this.$message.error('没有匹配的素材！')
      } else if (this.isFlow) { // 信息流 —— 组图
        if (this.form.information === '2') {
          if (files.length !== 3) {
            return this.$message.error('组图素材只能传素材三张图片！')
          }
        } else if (files.length !== 1) {
          return this.$message.error(`${this.form.information === '1' ? '小图' : '大图'}只能上传一张素材图片！`)
        }
      }

      this.form.materials.splice(index + 1, 0, {
        title: '',
        spread_name: '',
        fileList: [],
        replaceList: [],
        page: new this.$page({
          header: { preview: '素材', path: '素材名称', size: '素材尺寸', match: '是否匹配' }
        }),
        files: [],
        replacing: [],
        removing: [],
        visibles: [], // 删除素材组中的素材标识
        visible: false // 删除素材组标识
      })
      this.covers.splice(index + 1, 0, []) // 信息流视频封面
    },
    dataFilter(date) {
      let arr = []
      date.forEach(time => {
        let temp = []
        time.time.forEach(t => {
          if (t.length === 1) {
            temp.push(t < 10 ? ['0' + t, '0' + (parseInt(t) + 1)] : [t + '', parseInt(t) + 1 + ''])
          } else {
            temp.push(
              t.map((v, i) => {
                if (i === 1) {
                  v = parseInt(v) + 1
                }
                return v < 10 ? '0' + parseInt(v) : v + ''
              })
            )
          }
        })
        arr.push({
          date: time.date,
          time: temp
        })
      })
      return arr
    },
    async resetDate({ type = 'add' } = {}) {
      if (!this.form.order_id) {
        this.$refs.form.validateField('order_id')
        return this.$message.error('请先选择计划！')
      }
      let api = type === 'add'
        ? '/admin/schedule/when-add-ad'
        : '/admin/schedule/when-update-ad-' + type + '/' + this.id
      let params = type === 'add'
        ? {
          carousel: this.form.carousel,
          provinces: this.form.provinces,
          place_id: this.currentPlan.place_id,
          payment: this.currentPlan.payment
        }
        : type === 'now' ? {} : { carousel: this.form.carousel }

      if (type !== 'now') {
        if (this.putTimeType === 0) {
          this.$refs.date.clearDate()
        }
        if ((this.form.provinces && this.form.provinces.length < 1) || !this.form.carousel) {
          this.defaultDate = []
          return false
        }
      }

      const [err, res] = await capturedPost(api, params)
      if (err || res.code !== 1) this.$message.error((err || res).msg || '重置日期失败！')
      else {
        this.disabledTime = Array.isArray(res.data) || (this.isPreview || this.isInternal) ? {} : res.data
      }
    },
    handleCarouselChange() {
      if (this.form.material_size === '0') {
        this.resetDate({ type: this.type === 'edit' ? 'after' : 'add' })
      }
    },
    handleProvinceChange(value) {
      if (value.length > 0) this.$refs.form.clearValidate('provinces')

      if (this.form.material_size === '0' && this.type === 'add') {
        this.resetDate({ type: 'add' })
      }
    },
    handleRegionPickerChange({ original, formated }) {
      this.checkedCities = formated
    },
    handlePutTimeType(value) {
      this.form.is_long_time = this.putTimeType
      this.$refs.form.clearValidate('date')
      this.$refs.form.clearValidate('is_long_time')
    },
    handleDateSelect({ date, dateCycle }) {
      dateCycle = availableDate(dateCycle)
      this.receiveDate = date;
      this.receiveData = this.dataFilter(date);
      this.receiveDateRange = [...dateCycle];
      this.form.time = date
      this.form.date = [...dateCycle]
      if (date && date.length < 2 && date[0].time.length < 1) { // 处理当天都不可选情况
        this.form.date = []
      }
      this.$refs.form.validateField('date')

      if (date.length > 60) {
        this.$message.error('投放周期超过60天，请重新修改后再提交！')
      }
    },
    beforeUploadBlackWhite(file) {
      const isSupport = ['text/plain'].includes(file.raw.type)
      const isLt50M = file.raw.size / 1024 / 1024 <= 50;

      if (!isSupport) {
        this.$message.error('黑白名单文件格式不正确！')
        return false
      }

      if (!isLt50M) {
        this.$message.error('黑白名单文件大小不能超过 50M！')
        return false
      }
      return isSupport && isLt50M
    },
    async handleBlackWhiteChange(file, fileList) { // 上传黑白名单
      if (!this.beforeUploadBlackWhite(file)) return

      const formData = new FormData()
      formData.append('file', file.raw)
      this.uploadingTpl = true
      const [err, res] = await capturedPost('/interface/black-white-upload', formData)
      this.uploadingTpl = false
      if (err || res.code !== 1) this.$message.error((err || res).msg || '黑白名单上传失败！')
      else {
        this.form.black_white.value = res.data
        this.$refs.form.validateField('black_white.value')
        this.$message.success('黑白名单上传成功！')
      }
    },
    // 第三方检测
    handleAddMonitor(type) {
      this.form[type].push({
        value: '',
        key: Date.now()
      })
    },
    handleRemoveMonitor(item, type) {
      let index = this.form[type].indexOf(item)
      if (index !== -1) {
        this.form[type].splice(index, 1)
      }
    },
    filterMonitor(data, type) {
      return this.form[type].filter(item => item.value !== '').map(item => item.value).join(',')
    },
    getMonitor(data, type) {
      const arr = data.split(',')
      const newArr = []
      arr.forEach(item => {
        newArr.push({
          key: Date.now(),
          value: item
        })
      })
      return newArr
    },
    submitForm(formName) {
      if (this.verifying) return
      this.verifying = true
      if (this.submiting || this.submited) return this.$message.error('请勿重复提交数据！')
      this.$refs[formName].validate(async (valid, errors) => {
        if (valid) { /* eslint-disable camelcase */
          const text = this.type === 'edit' ? '修改' : this.type === 'copy' ? '复制' : '添加'
          const { aduser_id: adUserId, materials, open_screen_guide_text, apk_name: apkName, first_app_store, information, plan_hour_type: planHourType, carousel, pay_univalent, sex, age, stages_life, education, career, income, house, car, hobby, app_interest: appInterest, game_type, is_device_oriented: isDeviceOriented, black_white: blackWhite, monitor_pv_urls, monitor_urls, date, time, trail_color, ...formData } = this.form

          if (this.isFlow) { // 信息流 —— 校验最后一组素材
            if (this.form.information === '2') {
              if (materials[materials.length - 1].files.length !== 3) {
                this.verifying = false
                return this.$message.error('组图素材只能上传三张素材图片！')
              }
            } else if (materials[materials.length - 1].files.length !== 1) {
              this.verifying = false
              return this.$message.error(`${this.form.information === '1' ? '小图' : '大图'}只能上传一张素材图片！`)
            }
          }
          formData.time = this.putTimeType === 0 ? time : []
          if (formData.time.length > 0) {
            formData.time = formData.time.filter(item => {
              if (item.time.length > 0) { return item }
            })
          }
          if (formData.time.length > 60) {
            this.verifying = false
            return this.$message.error('投放周期超过60天，请重新修改后再提交')
          }
          this.submiting = true
          this.verifying = false

          if (this.isFlow) { // 信息流展示样式
            formData.information = this.supportedInformations.length > 0 ? information : '0'
          }
          formData.open_screen_guide_text = this.isOpenScreen ? open_screen_guide_text : ''
          if ((this.isFlow || this.isMotivate) && this.isVideo) { // 信息流视频
            formData.filenames = materials.map(({ title, spread_name: spreadName, files }, index) => {
              const material = { title, spread_name: spreadName }
              const covers = this.covers[index]
              material.files = files.reduce((acc, file, i) => {
                acc.push(file, covers[i] || { ...file, material_type: 2, create_type: 1 })
                return acc;
              }, [])
              return material
            })
          } else {
            formData.filenames = materials.map(({ title, spread_name: spreadName, files }) => ({ title, spread_name: spreadName, files }))
          }

          if (formData.jump_type === '2') { // 包名
            formData.apk_name = apkName
            formData.first_app_store = first_app_store
          }
          if (!this.isCPT) { // 投放控制/时
            formData.plan_hour_type = planHourType
            formData.cities = this.checkedCities
          } else {
            if (!(this.isPreview || this.isInternal)) { // 预览广告、内部联运推广广告不传轮播
              formData.carousel = carousel
            }
            formData.pay_univalent = pay_univalent
          }

          if (this.isApp) {
            if (isDeviceOriented !== '1') { // 否
              formData.media_ids = []
            }

            if (this.isYNW && formData.is_oriented === '1') { // 人群定向
              formData.stages_life = this.data.stagesLifes.map(v => v.value)
              formData.education = this.data.educations.map(v => v.value)
              formData.career = this.data.careers.map(v => v.value)
              formData.house = this.data.houses.map(v => v.value)
              formData.car = this.data.cars.map(v => v.value)
              formData.sex = sex
              formData.age = age
              formData.income = income
              formData.hobby = hobby
              formData.app_interest = appInterest

              if (!this.isN) { // NGA
                formData.game_type = this.data.gameTypes.map(v => v.value)
              } else {
                formData.game_type = game_type
              }
            } else {
              formData.is_oriented = '2'
            }

            formData.network_way = this.data.networkWays.map(v => v.value)
            formData.operator = this.data.operators.map(v => v.value)
          } else {
            formData.is_oriented = '2'
            // formData.is_black_white = '2'
          }

          if (!this.isM && (formData.is_black_white === '1' || formData.is_black_white === '0')) { // 黑白名单
            formData.black_white = {
              [formData.is_black_white === '1' ? '8' : '9']: blackWhite.value
            }
          } else {
            formData.is_black_white = '2'
          }
          formData.monitor_pv_urls = this.filterMonitor(monitor_pv_urls, 'monitor_pv_urls')
          formData.monitor_urls = this.filterMonitor(monitor_urls, 'monitor_urls')
          formData.nga_section_ids = this.form.ngaOrient ? this.form.add_nga_section_ids : []
          formData.date = this.putTimeType === 0 ? date : []
          formData.trail_color = getHexColor2(trail_color)
          const requestMethod = this.type === 'edit' ? capturedPut : capturedPost
          const [err, res] = await requestMethod(`/${this.platform}/ads${this.type === 'edit' ? '/' + this.id : ''}`, formData)
          this.submiting = false
          if (err || res.code !== 1) return this.$message.error((err || res).msg || `${text}广告失败！`)
          else {
            this.submited = true
            this.$message.success(`${text}广告成功！`)
            setTimeout(_ => this.$router.push('/advertiseList'), 2000)
          }
        } else {
          this.$message.error({
            message: h('div', { class: 'el-message__content' }, [
              h('p', {}, '请填写完整信息！'),
              h('br'),
              h('ol', { style: { 'list-style-type': 'decimal', 'padding-left': '15px' } }, Object.keys(errors).map(key => h('li', {}, errors[key][0].message)))
            ])
          })
          this.verifying = false
          return false
        }
      })
    }
  },
  async created() {
    const { type, id } = this.$route.params
    this.platform = this.$route.meta.platform
    this.type = type
    this.id = id
    this.loading = true
    if (this.id) {
      this.form.create_type = '' // 编辑清空素材类型
    }

    const items = new Map()
      // .set('jump_type', 'jumpTypes')
      .set('conversion_monitor_type', 'conversionMonitorTypes')
      .set('information', 'informations')
      .set('m_play', 'mPlays')
      .set('carousel', 'carousels')
      .set('provinces', 'provinces')
      .set('cities', 'cities')
      .set('plan_hour_type', 'planHourTypes')
      .set('is_media', 'devices')
      .set('media_ids-port_type_1', 'iOSDevices')
      .set('media_ids-port_type_2', 'androidDevices')
      .set('is_oriented', 'crowds')
      .set('age', 'ages')
      .set('sex', 'sexes')
      .set('stages_life', 'stagesLifes')
      .set('education', 'educations')
      .set('career', 'careers')
      .set('income', 'incomes')
      .set('house', 'houses')
      .set('car', 'cars')
      .set('hobby', 'hobbies')
      .set('app_interest', 'appInterests')
      .set('game_type', 'gameTypes')
      .set('network_way', 'networkWays')
      .set('operator', 'operators')
      .set('is_black_white', 'blackWhites')
      .set('black_white', 'blackWhiteKeys')
      .set('monitor_type', 'monitorTypes')

    const itemValues = [...items.values()]
    Promise.all(
      [...items.keys()].map(item =>
        get(`/interface/etcd/${item === 'cities' ? 'jsonitem' : 'item'}/${item}`)
      )
    ).then(results => {
      results.forEach((res, i) => {
        this.data[itemValues[i]] = res.data
      })
      this.jumpTypes = this.data.jumpTypes
    })
    this._getFirstAppStoreOptions()
    this.getAdUsers()

    if (this.id) { // 编辑、查看、复制
      const [err, res] = await capturedGet(`/${this.platform}/ads/${this.id}`)
      if (err || res.code !== 1) return this.$message.error((err || res).msg || '获取广告信息失败！')
      else { /* eslint-disable camelcase */
        const {
          advertiser_id, // 广告主
          order_id,
          create_type,
          ad_name,
          jump_type,
          deeplink,
          conversion_monitor_type,
          apk_name,
          first_app_store,
          ad_url,
          landing_page_pic,
          information,
          material,
          m_play,
          carousel,
          pay_univalent,
          provinces,
          cities,
          date,
          time,
          // budget,
          media_ids,
          is_oriented,
          orienteds,
          network_way,
          operator,
          is_black_white,
          black_white,
          monitor_type,
          monitor_pv_urls,
          monitor_urls,
          nga_section_ids,
          is_long_time,
          open_screen_guide_text,
          open_screen_set
        } = res.data
        // this.form.order_id = order_id
        // this.form.material_size = '0'
        const { interaction_mode, trail_color, trail_weight, guide_mode, warning_text } = open_screen_set || {}
        const formData = {
          aduser_id: advertiser_id,
          order_id,
          create_type,
          ad_name,
          jump_type,
          deeplink,
          conversion_monitor_type,
          apk_name,
          first_app_store: parseInt(first_app_store),
          ad_url,
          landing_page_pic,
          information,
          m_play,
          carousel,
          // carouselClone: carousel,
          pay_univalent,
          open_screen_guide_text,
          trail_color: getRgba(trail_color || '#000000FF'),
          trail_weight: trail_weight !== undefined ? trail_weight : 5,
          interaction_mode: interaction_mode !== undefined ? interaction_mode : '0',
          guide_mode,
          warning_text,
          date: this.type !== 'copy' ? date : [],
          time: this.type !== 'copy' ? time : [],
          // budget,
          is_device_oriented: media_ids.length > 0 ? '1' : '2',
          media_ids,
          is_oriented,
          age: orienteds ? orienteds.age : [],
          sex: orienteds ? orienteds.sex : [],
          stages_life: orienteds ? orienteds.stages_life : [],
          education: orienteds ? orienteds.education : [],
          career: orienteds ? orienteds.career : [],
          income: orienteds ? orienteds.income : [],
          house: orienteds ? orienteds.house : [],
          car: orienteds ? orienteds.car : [],
          hobby: orienteds ? orienteds.hobby : [],
          app_interest: orienteds ? orienteds.app_interest : [],
          game_type: orienteds ? orienteds.game_type : [],
          network_way,
          is_long_time,
          operator,
          is_black_white,
          black_white: { key: '', value: '' },
          monitor_type,
          nga_section_ids,
          ngaOrient: nga_section_ids.length > 0 ? 1 : 0
        }

        this.putTimeType = parseInt(is_long_time)
        this.originalAdName = ad_name
        if (black_white) { // !black_white ? { key: '', value: '' }
          const [key, value] = Object.entries(JSON.parse(black_white))[0]
          formData.black_white.key = key
          formData.black_white.value = value
        }

        if (monitor_type !== '0') {
          formData.monitor_pv_urls = this.getMonitor(monitor_pv_urls, 'monitor_pv_urls')
          formData.monitor_urls = this.getMonitor(monitor_urls, 'monitor_urls')
        }

        formData.materials = material.length > 0 ? material.map((item, index) => {
          let { title, spread_name, files } = item

          const masterFiles = files.filter(file => file.material_type === '1') // 过滤出主素材
          const coverFiles = files.filter(file => file.material_type === '2')

          const result = {
            title,
            spread_name,
            fileList: [],
            replaceList: [],
            replacing: Array.from({ length: masterFiles.length }).fill(false),
            removing: Array.from({ length: masterFiles.length }).fill(false),
            visibles: Array.from({ length: masterFiles.length }).fill(false),
            visible: false
          }

          result.page = new this.$page({
            header: { preview: '素材', path: '素材名称', size: '素材尺寸', match: '是否匹配' },
            data: masterFiles.map(({ id, path, size, seconds, file_size }, index) => {
              const item = { id: this.type !== 'copy' ? id : undefined, preview: path, path, size, match: true }
              if (create_type === '2' || create_type === '3') {
                item.seconds = seconds
                item.file_size = file_size
              }
              if (coverFiles[index]) {
                item.coverPath = coverFiles[index].path
              }
              return item
            })
          })

          result.files = masterFiles.map(({ id, path, size, seconds, file_size, size_id, code }) => {
            const item = { id: this.type !== 'copy' ? id : undefined, path, size, size_id, code }
            if (create_type === '2' || create_type === '3') {
              item.seconds = seconds
              item.file_size = file_size
            }
            return item
          })
          return result
        }) : [{
          title: '',
          spread_name: '',
          fileList: [],
          replaceList: [],
          page: new this.$page({
            header: { preview: '素材', path: '素材名称', size: '素材尺寸', match: '是否匹配' }
          }),
          files: [],
          replacing: [],
          removing: [],
          visibles: [], // 删除素材组中的素材标识
          visible: false // 删除素材组标识
        }]

        if (this.isCPT) {
          formData.provinces = provinces
        } else {
          formData.cities = this.$refs.regionPicker.getSelectedData(this.data.cities, cities)
          this.defaultCities = cities
        }

        this.form = Object.assign({}, this.form, formData)
        await this.getPlansByAdUserId(advertiser_id)
        await this.handleAdPlanChange(order_id)

        this.receiveDate = this.type !== 'copy' ? time : []
        this.receiveData = this.type !== 'copy' ? this.dataFilter(time) : []
        this.receiveDateRange = this.type !== 'copy' ? availableDate(date) : []
        this.defaultProvinces = provinces

        if (this.isFlow) { // 获取素材尺寸
          this.handleInformationChange(information)
        }

        if ((this.isFlow || this.isMotivate) && this.isVideo) { // 信息流视频
          this.covers = material.length > 0 ? material.reduce((acc, item) => {
            acc.push(item.files.filter(file => file.material_type === '2'))
            return acc
          }, []) : [[]]
        }

        // 重置投放时间校验
        this.$nextTick(_ => {
          this.$refs.form.clearValidate('date')
          this.isEditFirst = false
          // this.$refs.ngaOrient.addToAims()
          setTimeout(() => {
            if (this.$refs.ngaOrient) {
              this.$refs.ngaOrient.addToAims(true)
            }
          }, 1000)
        })
      }
    }
    this.loading = false
  }
}
</script>

<style lang="scss">
@include b(advertise-opr) {
  .up-form-item-checkbox__all {
    float: left;
    margin-right: 20px;
  }

  @include e(preview) {
    .el-carousel__container {
      height: 420px;
    }
  }

  @include e(preview-image) {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    max-width: 100%;
    max-height: 100%;
    margin: auto;
  }

  .icon-iconfontquestion {
    color: #fc8675;
  }

  @include e(landpage) {
    position: relative;

    .icon-iconfontquestion {
      color: #fc8675;
    }
  }

  @include e(landpage-message) {
    @include is(correct) {
      color: #66cfa7;
    }
    @include is(wrong) {
      color: #fc8675;
    }
  }

  @include e(landpage-upload) {
    .el-upload {
      margin-left: 16px;
    }
  }

  @include e(landpage-tip) {
    position: absolute;
    top: 0;
    left: 170px;
  }

  @include e(landpage-pic) {
    margin-left: 16px;
    max-width: 364px;
    max-height: 200px;

    img {
      max-width: 100%;
      max-height: 200px;
      height: auto;
    }
  }

  @include e(material-scale) {
    margin-left: 16px;
    span {
      color: #999;

      &:last-child {
        margin-left: 20px;
      }
    }
  }

  @include e(material-size) {
    margin-left: 16px;

    li {
      float: left;
      height: 30px;
      margin-right: 10px;
      padding: 0 10px;
      font-size: 14px;
      line-height: 30px;

      @include is(active) {
        color: #fff;
        background-color: #495b6c;
      }
    }
  }

  @include e(upload-tip) {
    margin-left: 16px;
    font-size: 12px;
    color: #fc8675;
  }

  @include e(table) {
    margin-top: 16px;
    margin-left: 16px;

    .icon-right {
      color: #66cfa7;
    }

    .icon-wrong {
      color: #fc8675;
    }

    .is-path {
      text-decoration: underline;
      color: #1c8de0;
    }

    .is-preview {
      max-width: 100%;
      max-height: 100px;
      margin: 0 auto;
    }
  }

  @include e(replace) {
    display: inline-block;
  }

  @include e(group) {
    margin-bottom: 22px;
  }

  @include e(list) {
    padding: 10px 0;
    // border: 1px solid #3dc1c4;
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  @include e(date-range) {
    .finallyDate {
      margin-left: 16px;
    }
  }

  @include e(device) {
    .el-transfer-panel {
      width: 264px;
    }

    .el-transfer-panel__item {
      &.el-checkbox {
        display: block;
      }
    }
  }

  @include e(crowd) {
    position: relative;
    margin-left: 136px;
    margin-bottom: 22px;
    padding: 0px 0 10px 12px;
    background: #f9f9f9;

    h3 {
      line-height: 32px;
    }
  }

  @include e(crowd-list) {
    margin-left: 40px;
  }

  @include e(crowd-item) {
    overflow: hidden;

    &:last-child {
      margin-bottom: 0;
    }

    .el-form-item__error {
      margin-left: 0;
    }

    .el-form-item__content {
      float: left;
      width: 702px;
      margin-left: 0 !important;
    }
  }

  @include e(crowd-type) {
    float: left;
    width: 120px;
    height: 28px;
    line-height: 28px;
  }

  @include e(bw-type) {
    .el-radio-group {
      margin-left: 16px;
    }
  }

  @include e(bw) {
    position: relative;
    margin-left: 16px;
    margin-bottom: 4px;
  }

  @include e(bw-tip) {
    margin-left: 16px;
    color: #ff4949;
  }

  @include e(bw-upload) {
    display: inline-block;

    .el-upload {
      text-align: left;
    }
  }

  @include e(bw-url) {
    margin-left: 10px;
  }

  @include e(bw-template) {
    margin-left: 3px;
    font-size: 12px;
    color: #4990e2;
    cursor: pointer;
  }

  @include e(btns) {
    margin-left: 136px;
  }

  @include e(btn) {
    margin-left: 10px;
  }
  @include e(monitor) {
    margin-bottom: 0;
    &>.el-form-item__content{
      display: flex;
      flex-direction: column;
    }
    .el-form-item{
      margin-bottom: 22px;
    }
  }
  @include e(nga) {
    max-width: 816px;
    .custom-tree-node{
      margin-left: 10px;
    }
  }
}
</style>
